import React from 'react';
import { observer } from "mobx-react";

import {
  BaseModelCollection,
  AppState,
  Group,
  getGroups,
  getAppState,
} from '../models';

import {
  BaseCollectionPage,
} from './BaseCollectionPage';
import { TextField, List, Subheader, ListItem, Button } from "react-md";
import { getApi } from "../api";
import HelpView from "../components/HelpView";


interface GroupsProps {
  history?: any;
  match?: any;
  location?: any;
}

type ComponentState = any;



@observer
class Groups extends BaseCollectionPage<GroupsProps, ComponentState> {
  viewName = 'Groups';
  objectName = 'group';
  store = 'my_models';

  get objectLabel() {
    return "Group";
  }

  

  
  

  

  getCollection(): BaseModelCollection {
    return getGroups();
  }

  getAppState(): AppState {
    return getAppState();
  }

  get customFilters(): any[] {
    let filters: any = []
    
      filters = ["created_by","members"]
    

    let customFilters: any[] = [];

    let obj = new Group();
    filters.forEach((key: string) => {
      let field = obj.getFieldInfo(key);
      if (!field) return;

      let filter: any = {
        key: key,
        label: field.label,
        type: field.type,
      };

      if ((field.type == 'model') || (field.type == 'models')) {
        filter['collectionName'] = field.objectName;
      }

      if (field.type == 'select') {
        filter['options'] = field.options;
      }

      customFilters.push(filter);
    })

    return customFilters;
  }

  

  

  

  
  


}

export default Groups;